import { SyncDescriptor } from 'vscode/vscode/vs/platform/instantiation/common/descriptors';
import { MultiDiffSourceResolverService } from 'vscode/vscode/vs/workbench/contrib/multiDiffEditor/browser/multiDiffSourceResolverService';
import { IMultiDiffSourceResolverService } from 'vscode/vscode/vs/workbench/contrib/multiDiffEditor/browser/multiDiffSourceResolverService.service';
import './vscode/src/vs/workbench/contrib/multiDiffEditor/browser/multiDiffEditor.contribution.js';

function getServiceOverride() {
    return {
        [( IMultiDiffSourceResolverService.toString())]: new SyncDescriptor(MultiDiffSourceResolverService, [], true)
    };
}

export { getServiceOverride as default };
